import { useTitle } from 'react-use';

export const SetPageTitle = (title?: string): null => {
  const subtitle = title ? `${title} - ` : '';
  const fullTitle = `${subtitle}Between Worlds`;
  useTitle(fullTitle);

  return null;
};
